import useFrontendBoot from "@/Hooks/useFrontendBoot";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import { IChartGraphProps } from "./graphs.types";

const AreaChartGraph = ({
  data,
  xKeyName,
  yKeyName,
  tooltipComp,
  CustomizedXAxisTickComp,
}: IChartGraphProps) => {
  const { brokerFrontendBoot } = useFrontendBoot();

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 10,
          right: 10,
          left: 10,
          bottom: 10,
        }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor={brokerFrontendBoot?.settings?.theme?.primary_color}
              stopOpacity={0.7}
            />
            <stop
              offset="50%"
              stopColor={brokerFrontendBoot?.settings?.theme?.primary_color}
              stopOpacity={0.5}
            />
            <stop
              offset="95%"
              stopColor={brokerFrontendBoot?.settings?.theme?.primary_color}
              stopOpacity={0.0}
            />
          </linearGradient>
        </defs>
        <XAxis
          tickLine={false}
          axisLine={false}
          dataKey={xKeyName}
          tick={CustomizedXAxisTickComp}
          padding={{
            left: 10,
            right: 10,
          }}
          interval={0}
          textAnchor="middle"
        />
        <CartesianGrid vertical={false} opacity={0.2} />
        <Tooltip cursor={false} content={tooltipComp} />
        <Area
          type="monotone"
          dataKey={yKeyName || ""}
          stroke={brokerFrontendBoot?.settings?.theme?.primary_color}
          fillOpacity={1}
          fill="url(#colorUv)"
          activeDot={{ r: 5 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AreaChartGraph;
